'use strict';

define('RaceInfoFac',[
        'lodash'
    ],
    function (_) {
        function RaceInfoFac() {
            var _lowestOdd = Number.MAX_VALUE;

            function _setLowestOdd(arr) {
                _lowestOdd = Number.MAX_VALUE;
                var myOdd = Number.MAX_VALUE;

                //filter scratched horses for odd calculation
                var newArr = arr.length ? arr.filter(function (bettingInterest) {
                        var available = false;
                        var runners = bettingInterest.runners || bettingInterest.Runners;
                        _.each(runners, function (runner) {
                            var scratched = runner.scratched || runner.Scratched;
                            if (!scratched) {
                                available = true;
                            }
                        });
                        return available;
                    }) : [];

                for (var i = 0; i < newArr.length; i++) {

                    myOdd = _getDecimalOddsValue(newArr[i].CurrentOdds || newArr[i].currentOdds);

                    if (myOdd < _lowestOdd) {
                        _lowestOdd = myOdd;
                    }

                }
            }

            function _isFavoriteBIScratched(bettingInterests) {
                var isFavoriteBIScratched = false;

                bettingInterests.forEach(function (bettingInterest) {
                    var runners = bettingInterest.runners || bettingInterest.Runners || [bettingInterest];
                    
                    _.each(runners, function (runner) {
                        var scratched = runner.scratched || runner.Scratched;
    
                        if (bettingInterest.favorite && scratched) {
                            isFavoriteBIScratched = true;
                            return isFavoriteBIScratched;
                        }
                    });
                });
                return isFavoriteBIScratched;
            }

            function _isFavoriteOdd(bettingInterest) {
                return _lowestOdd === _getDecimalOddsValue(bettingInterest.currentOdds) && _lowestOdd !== 99;
            }

            function _getLowestOdd() {
                return _lowestOdd;
            }

            function _getDecimalOddsValue(obj) {
                if (obj) {
                    var denominator = obj.denominator;
                    var numerator = obj.numerator;
                    var decimal = denominator ? numerator / denominator : numerator;

                    if (isNaN(decimal)) {
                        return Number.MAX_VALUE;
                    }
                    return parseFloat(decimal);
                }
                else {
                    return Number.MAX_VALUE;
                }
            }


            return {
                setLowestOdd: _setLowestOdd,
                getLowestOdd: _getLowestOdd,
                isFavoriteOdd: _isFavoriteOdd,
                isFavoriteBIScratched: _isFavoriteBIScratched
            };
        }

        RaceInfoFac.$inject = [];

        return RaceInfoFac;

    });

